import * as d3 from 'd3';

import Constants from './Constants';
import { ordinalColorScale } from './Utils';

class TopicVizScaling {
  public scaleFactor: number;
  public opacityDocumentPoints: any;
  public opacitySubTopics: (value) => any;
  public opacityDocumentCards: any;
  public opacityTopics: any;
  public colorScale: (index) => string;
  public xScale: (value) => number;
  public yScale: (value) => number;
  public numberOfWordElementsScale: (value) => number;

  constructor(documentDataPoints, width, height) {
    this.scaleFactor = 1;

    this.colorScale = ordinalColorScale();

    this.xScale = d3
      .scaleLinear()
      .domain([
        +d3.min(documentDataPoints, (d: any) => d.x),
        +d3.max(documentDataPoints, (d: any) => d.x),
      ])
      .range([
        Constants.general.padding,
        width - Constants.general.padding * 2,
      ]);

    this.yScale = d3
      .scaleLinear()
      .domain([
        +d3.min(documentDataPoints, (d: any) => d.y),
        +d3.max(documentDataPoints, (d: any) => d.y),
      ])
      .range([height - Constants.general.padding, Constants.general.padding]);

    this.numberOfWordElementsScale = d3
      .scaleLinear()
      .domain([0.5, 15])
      .range([20, 60]);
  }

  setScaleFactor(factor) {
    this.scaleFactor = factor;
  }

  getScaleFactor() {
    return this.scaleFactor;
  }
}

export default TopicVizScaling;
